<script>
import TooltipSelectorMixin from '~/components/decks/tooltip-selector/TooltipSelectorMixin'
import { reportingStates } from '~/common/reporting'

const { RECAP_ONLY, RATINGS_ONLY, NONE, ALL } = reportingStates

export default {
  name: 'ReportingSelector',
  mixins: [TooltipSelectorMixin],
  data () {
    return {
      options: [
        // disableSounds
        { id: ALL, label: 'All', icon: 'check-double' },
        { id: RECAP_ONLY, label: 'Recap Only', emoji: '/illustration/recap.svg', isPro: true },
        { id: RATINGS_ONLY, label: 'Ratings Only', emoji: '/illustration/ratings.svg', isPro: true },
        { id: NONE, label: 'None', icon: 'ban', isPro: true }
      ]
    }
  }
}
</script>
